module.exports = __webpack_public_path__ + "img/comercial.8895977f.png";